import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, getAuthToken } from '../../auth/context/AuthContext';

const API = `${process.env.REACT_APP_API_URL || 'https://recruitai.pingitright.com/api'}/auth`;

export default function Profile() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [err, setErr] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user?.name) setName(user.name);
  }, [user?.name]);

  const saveProfile = async (e) => {
    e.preventDefault();
    setErr('');
    setNote('');
    setSaving(true);
    try {
      const res = await fetch(`${API}/profile`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === 'string' ? data.detail : 'Could not update profile');
      setUser(data);
      setNote('Profile updated.');
    } catch (error) {
      setErr(error.message);
    }
    setSaving(false);
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Update profile</div>
          <div className="page-subtitle">Your name can change. Your email stays the same.</div>
        </div>
      </div>
      <form className="card" onSubmit={saveProfile} style={{ maxWidth: 520 }}>
        {err && <div className="alert alert-error" style={{ marginBottom: 12 }}>{err}</div>}
        {note && <div style={{ fontSize: 13, marginBottom: 12 }}>{note}</div>}
        <label className="form-group">
          <div className="form-label">Name</div>
          <input className="form-input" value={name} onChange={(e) => setName(e.target.value)} required />
        </label>
        <label className="form-group">
          <div className="form-label">Email</div>
          <input className="form-input" value={user?.email || ''} disabled readOnly />
        </label>
        <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
          {saving ? 'Saving…' : 'Save profile'}
        </button>
        <div style={{ marginTop: 14, fontSize: 13 }}>
          <Link to="/change-password">Change password</Link>
        </div>
      </form>
    </div>
  );
}
